import React from 'react';
import { Link } from 'react-router-dom';
import './FashionDiscovery.scss';

import womenImage from './img/fashion/women.jpg';
import menImage from './img/fashion/men.jpg';
import kidsImage from './img/fashion/kids.jpg';
import catClothingImage from './img/fashion/cat-clothing.jpg';
import catShoesImage from './img/fashion/cat-shoes.jpg';
import catBagsImage from './img/fashion/cat-bags.jpg';
import catAccessoriesImage from './img/fashion/cat-accessories.jpg';
import catBeautyImage from './img/fashion/cat-beauty.jpg';

// Shopping Taxonomy v1 (fashion-first architecture, 2026-09) — Audience and
// Department facets, exactly as agreed with server/shared/shoppingTaxonomy.js
// (AUDIENCES / DEPARTMENTS). Values here are the literal strings the backend
// crosswalk resolves to — keep in sync with that file if it ever changes.
const AUDIENCE_TILES = [
  { value: 'women', label: 'Жінкам', image: womenImage },
  { value: 'men', label: 'Чоловікам', image: menImage },
  { value: 'kids', label: 'Дітям', image: kidsImage },
];

const DEPARTMENT_CHIPS = [
  { value: 'clothing', label: 'Одяг', image: catClothingImage },
  { value: 'shoes', label: 'Взуття', image: catShoesImage },
  { value: 'bags', label: 'Сумки', image: catBagsImage },
  { value: 'accessories', label: 'Аксесуари', image: catAccessoriesImage },
  { value: 'beauty', label: 'Beauty', image: catBeautyImage },
];

// Home's fashion-first discovery entry (2026-09, made compact after a
// production density pass). NAVIGATION links, not a Home-feed filter —
// Home's own discovery grid always stays the general fashion feed
// (shoppingOnly=1). Clicking a tile/chip takes the user to SearchResults
// (the real fashion browse screen) with that shopping context in the URL.
export default function FashionDiscovery() {
  return (
    <div className="fashion-discovery">
      <div className="fashion-discovery__audience" role="group" aria-label="Оберіть аудиторію">
        {AUDIENCE_TILES.map((tile) => (
          <Link key={tile.value} to={`/search?audience=${tile.value}`} className="fashion-tile">
            <img src={tile.image} alt="" loading="eager" decoding="async" draggable={false} />
            <span className="fashion-tile__overlay">
              <span className="fashion-tile__label">{tile.label}</span>
              <svg className="fashion-tile__arrow" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        ))}
      </div>

      <div className="fashion-discovery__departments" role="group" aria-label="Оберіть категорію">
        {DEPARTMENT_CHIPS.map((chip) => (
          <Link key={chip.value} to={`/search?department=${chip.value}`} className="fashion-chip">
            <span className="fashion-chip__image-wrap">
              <img src={chip.image} alt="" loading="lazy" decoding="async" draggable={false} />
            </span>
            <span className="fashion-chip__label">{chip.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
